import { render } from "./Voice.vue?vue&type=template&id=6da45e16&scoped=true"
import script from "./Voice.vue?vue&type=script&lang=js"
export * from "./Voice.vue?vue&type=script&lang=js"

import "./Voice.vue?vue&type=style&index=0&id=6da45e16&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6da45e16"]])

export default __exports__